import PptxGenJS from "pptxgenjs";
import { TEXT_OPTIONS } from "../masters/components";
import { TemplateData } from "../index";
import { parseMarkdownToPptxText } from "../../../markdownParser";

const RIGHT_COLUMN_X = 8.99;
const LEFT_COLUMN_X = 0.52;
const COLUMN_Y = 2.0;

export const addPsychSummarySlide = (pres: PptxGenJS, data: TemplateData) => {
  const slide = pres.addSlide({ masterName: "SPLIT_RIGHT_MASTER" });
  slide.addText("Candidate Profile Summary", { placeholder: "title" });

  const likelyStrengths = data.likelyStrengths;
  const areasToProbe = data.areasToProbe;

  if (data.candidateName) {
    slide.addText(data.candidateName, {
      ...TEXT_OPTIONS.caption,
      x: LEFT_COLUMN_X,
      y: 1.14,
      fontSize: 18,
    });
  }

  const columnsBaseOptions = {
    y: COLUMN_Y,
    w: 6.81,
    h: 5.2,
    valign: "top",
  } as const;

  slide.addText(
    [
      {
        text: "Likely Strengths",
        options: { ...TEXT_OPTIONS.caption, align: "left" },
      },
      ...(likelyStrengths ? parseMarkdownToPptxText(likelyStrengths) : []),
    ],
    {
      ...columnsBaseOptions,
      x: LEFT_COLUMN_X,
    }
  );

  slide.addText(
    [
      {
        text: "Areas to probe",
        options: { ...TEXT_OPTIONS.caption, align: "left" },
      },
      ...(areasToProbe ? parseMarkdownToPptxText(areasToProbe) : []),
    ],
    {
      ...columnsBaseOptions,
      x: RIGHT_COLUMN_X,
    }
  );
};
